export function millisecondsFromHours(hours) {
    return hours * 60 * 60 * 1000;
}

export function startOfDay(date) {
    const start = new Date(date);
    start.setHours(0, 0, 0, 0);
    return start;
}

export function sleep(duration) {
    return new Promise((resolve) => setTimeout(resolve, duration));
}

export function dayProgress(date) {
    function map(n, low1, high1, low2, high2) {
        return low2 + (high2 - low2) * ((n - low1) / (high1 - low1));
    }

    function ease(l) {
        if (l < 0.5) {
            const p = map(l, 0.0, 0.5, 0.0, 1.0);
            const f = p - 1;
            let e = 0.0;

            if (p < 0.5) {
                e = 8 * p * p * p * p;
            } else {
                const f = p - 1;
                e = -8 * f * f * f * f + 1;
            }

            return e * 0.5;
        } else {
            const p = map(l, 0.5, 1.0, 0.0, 1.0);
            return 0.5 + p * p * p * p * 0.5;
        }
    }

    const start = startOfDay(date);
    const duration = millisecondsFromHours(24);
    const linear = (date.getTime() - start.getTime()) / duration;
    const eased = ease(linear);

    return eased;
}
